/* QC site pages (qc-pg-* sections): Klaviyo form buttons (Ambassadors APPLY NOW, Invitation CLAIM INVITATION) and the Pro Team member switcher. */
(function () {
  if (window.__qcPg) return;
  window.__qcPg = true;

  /* APPLY NOW (Ambassadors): open a Klaviyo sign-up form when Klaviyo's onsite script is on the page. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qc-klaviyo-form]');
    if (!btn) return;
    var id = btn.getAttribute('data-qc-klaviyo-form');
    if (window._klOnsite && id) {
      e.preventDefault();
      window._klOnsite.push(['openForm', id]);
    } else if (btn.getAttribute('href') === '#') {
      e.preventDefault();
    }
  });


  /* Pro Team: "QC Page: Pro Team" (cards / picker) + one "QC Page: Team member" section per member.
     Exactly one member section is shown (the first by default). Card N opens member section N (page order);
     the arrows go to the previous / next member and loop; swipe on a profile does the same on phones.
     About (mobile) closes again when the member changes. */
  var teamOn = 0;
  function teamMembers() { return Array.prototype.slice.call(document.querySelectorAll('.qc-pg-member')); }
  function teamShow(i) {
    var ms = teamMembers(), n = ms.length;
    if (!n) return;
    i = ((i % n) + n) % n; teamOn = i;
    ms.forEach(function (m, k) {
      m.hidden = k !== i;
      var pos = m.querySelector('[data-qc-team-pos]');
      if (pos) pos.textContent = (k < 9 ? '0' : '') + (k + 1) + ' / ' + (n < 10 ? '0' : '') + n;
      var ab = m.querySelector('.qc-pg-team__about');
      if (ab) { ab.classList.remove('open'); var b = ab.querySelector('[data-qc-team-about]'); if (b) b.setAttribute('aria-expanded', 'false'); }
    });
    document.querySelectorAll('[data-qc-team-pick]').forEach(function (b) {
      var on = +b.getAttribute('data-qc-team-pick') === i;
      if (b.hasAttribute('aria-expanded')) b.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (b.hasAttribute('aria-pressed')) b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var prof = ms[+b.getAttribute('data-qc-team-pick')];
      var sec = prof && prof.querySelector('[data-qc-team-prof]');
      if (sec) b.setAttribute('aria-controls', sec.id);
    });
  }
  function teamInit() {
    if (!teamMembers().length) return;
    teamShow(teamOn);
    document.documentElement.classList.add('qc-team-ready');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', teamInit); else teamInit();
  document.addEventListener('shopify:section:load', teamInit);
  document.addEventListener('shopify:section:unload', function () { setTimeout(teamInit, 0); });
  /* Theme editor: selecting a member section shows it */
  document.addEventListener('shopify:section:select', function (e) {
    var m = e.target && e.target.querySelector && e.target.querySelector('.qc-pg-member');
    if (m) teamShow(teamMembers().indexOf(m));
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var pick = e.target.closest('[data-qc-team-pick]');
    if (pick) { teamShow(+pick.getAttribute('data-qc-team-pick')); return; }
    if (e.target.closest('[data-qc-team-next]')) { teamShow(teamOn + 1); return; }
    if (e.target.closest('[data-qc-team-prev]')) { teamShow(teamOn - 1); return; }
    var ab = e.target.closest('[data-qc-team-about]');
    if (ab) {
      var wrap = ab.closest('.qc-pg-team__about');
      var open = !wrap.classList.contains('open');
      wrap.classList.toggle('open', open);
      ab.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  });
  var tx = null, ty = null;
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest || !e.target.closest('[data-qc-team-prof]')) { tx = null; return; }
    tx = e.touches[0].clientX; ty = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (tx === null) return;
    var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty; tx = null;
    if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    teamShow(teamOn + (dx < 0 ? 1 : -1));
  }, { passive: true });

})();
